// SacBotAnacapri.js
(function () {
  const BRAND_RED = "#E30613";
  const BRAND_RED_DARK = "#b9000b";

  const LCW_SCRIPT_ID = "Microsoft_Omnichannel_LCWidget";
  const STYLE_ID = "anacapri-omni-styles";
  const LAUNCHER_ID = "anacapri-omni-launcher";
  const OPEN_CLASS = "anacapri-chat-open";

  const APP_ID = "636c577f-c98a-4a80-9bf9-07cd1c0c894d";
  const ORG_ID = "b606a206-e1ad-f011-8706-000d3ac0a3e4";
  const ORG_URL = "https://m-b606a206-e1ad-f011-8706-000d3ac0a3e4.br.omnichannelengagementhub.com";

  const LAUNCHER_LOGO_URL =
    "https://cdn.shopify.com/s/files/1/0700/0178/6934/files/Recurso_1_63ccea89-9ff7-45a7-b97a-dab9db6074bd.svg?v=1761678320";

  let sdkReady = false;
  let pendingStart = false;

  function injectStyles() {
    let style = document.getElementById(STYLE_ID);

    if (!style) {
      style = document.createElement("style");
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }

    style.innerHTML = `
      :root {
        --anacapri-red: ${BRAND_RED};
        --anacapri-red-dark: ${BRAND_RED_DARK};
      }

      html {
        overflow-x: hidden !important;
        scrollbar-gutter: stable !important;
      }

      body {
        overflow-x: hidden !important;
      }

      #lcw-chat-button,
      button[id*="lcw-chat-button"],
      button[id*="lcw"][aria-label*="chat"],
      button[id*="lcw"][aria-label*="Chat"] {
        display: none !important;
      }

      #anacapri-omni-launcher {
        position: fixed !important;
        right: 20px !important;
        bottom: 20px !important;
        left: auto !important;
        top: auto !important;
        z-index: 2147483000 !important;

        width: 218px !important;
        height: 58px !important;
        max-width: calc(100vw - 32px) !important;

        display: flex !important;
        align-items: center !important;
        justify-content: flex-start !important;
        gap: 10px !important;

        padding: 6px 16px 6px 6px !important;
        border: 0 !important;
        border-radius: 999px !important;

        background: #ffffff !important;
        color: #222222 !important;
        box-shadow: 0 8px 22px rgba(0,0,0,.16) !important;

        font-family: var(--font-body-family, var(--font-heading-family, Arial, Segoe UI, sans-serif)) !important;
        cursor: pointer !important;
        user-select: none !important;

        transform: none !important;
        transition: box-shadow .16s ease, background-color .16s ease !important;
        overflow: hidden !important;
        contain: layout paint style !important;
      }

      #anacapri-omni-launcher:hover {
        transform: none !important;
        box-shadow: 0 10px 26px rgba(0,0,0,.20) !important;
      }

      #anacapri-omni-launcher:focus,
      #anacapri-omni-launcher:focus-visible,
      #anacapri-omni-launcher *:focus,
      #anacapri-omni-launcher *:focus-visible {
        outline: none !important;
      }

      #anacapri-omni-launcher.is-hidden {
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }

      .anacapri-omni-launcher-logo {
        width: 46px !important;
        height: 46px !important;
        min-width: 46px !important;
        max-width: 46px !important;

        display: block !important;
        object-fit: contain !important;
        object-position: center !important;

        padding: 8px !important;
        box-sizing: border-box !important;

        border: 0 !important;
        border-radius: 50% !important;
        background: ${BRAND_RED} !important;
        box-shadow: none !important;
      }

      .anacapri-omni-launcher-text {
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-start !important;
        justify-content: center !important;

        line-height: 1.08 !important;
        white-space: nowrap !important;
        min-width: 0 !important;
      }

      .anacapri-omni-launcher-title {
        font-family: var(--font-heading-family, var(--font-body-family, Arial, Segoe UI, sans-serif)) !important;
        font-size: 17px !important;
        font-weight: 800 !important;
        color: #222222 !important;
        line-height: 1.1 !important;
        letter-spacing: -0.01em !important;
      }

      .anacapri-omni-launcher-status {
        margin-top: 3px !important;
        font-family: var(--font-body-family, Arial, Segoe UI, sans-serif) !important;
        font-size: 13px !important;
        font-weight: 400 !important;
        color: #888888 !important;
        line-height: 1.1 !important;
      }

      /*
        Clave:
        El iframe queda SIEMPRE fijo.
        No se mueve al cerrar, solo se oculta visualmente.
      */
      iframe[id*="Microsoft_Omnichannel"],
      iframe[id*="lcw"],
      iframe[src*="omnichannel"],
      iframe[src*="livechatwidget"],
      iframe[title*="chat"],
      iframe[title*="Chat"] {
        position: fixed !important;
        right: 24px !important;
        bottom: 24px !important;
        left: auto !important;
        top: auto !important;

        width: 370px !important;
        max-width: calc(100vw - 48px) !important;
        min-width: 0 !important;

        height: min(590px, calc(100vh - 48px)) !important;
        max-height: calc(100vh - 48px) !important;
        min-height: 0 !important;

        border: 0 !important;
        outline: 0 !important;
        border-radius: 18px !important;
        overflow: hidden !important;
        clip-path: inset(0 round 18px) !important;
        box-shadow: 0 14px 38px rgba(0,0,0,.22) !important;

        z-index: 2147482999 !important;
        transform: none !important;
        transition: none !important;
      }

      body:not(.${OPEN_CLASS}) iframe[id*="Microsoft_Omnichannel"],
      body:not(.${OPEN_CLASS}) iframe[id*="lcw"],
      body:not(.${OPEN_CLASS}) iframe[src*="omnichannel"],
      body:not(.${OPEN_CLASS}) iframe[src*="livechatwidget"],
      body:not(.${OPEN_CLASS}) iframe[title*="chat"],
      body:not(.${OPEN_CLASS}) iframe[title*="Chat"] {
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }

      body.${OPEN_CLASS} iframe[id*="Microsoft_Omnichannel"],
      body.${OPEN_CLASS} iframe[id*="lcw"],
      body.${OPEN_CLASS} iframe[src*="omnichannel"],
      body.${OPEN_CLASS} iframe[src*="livechatwidget"],
      body.${OPEN_CLASS} iframe[title*="chat"],
      body.${OPEN_CLASS} iframe[title*="Chat"] {
        opacity: 1 !important;
        visibility: visible !important;
        pointer-events: auto !important;
      }

      @media (min-width: 1440px) {
        iframe[id*="Microsoft_Omnichannel"],
        iframe[id*="lcw"],
        iframe[src*="omnichannel"],
        iframe[src*="livechatwidget"],
        iframe[title*="chat"],
        iframe[title*="Chat"] {
          right: 28px !important;
          bottom: 28px !important;
          width: 390px !important;
          max-width: calc(100vw - 56px) !important;
          height: min(620px, calc(100vh - 56px)) !important;
          max-height: calc(100vh - 56px) !important;
        }
      }

      @media (min-width: 600px) and (max-width: 899px) {
        iframe[id*="Microsoft_Omnichannel"],
        iframe[id*="lcw"],
        iframe[src*="omnichannel"],
        iframe[src*="livechatwidget"],
        iframe[title*="chat"],
        iframe[title*="Chat"] {
          right: 14px !important;
          bottom: 14px !important;
          width: min(390px, calc(100vw - 28px)) !important;
          max-width: calc(100vw - 28px) !important;
          height: min(620px, calc(100vh - 28px)) !important;
          max-height: calc(100vh - 28px) !important;
        }
      }

      @media (max-width: 599px) {
        #anacapri-omni-launcher {
          right: 12px !important;
          bottom: 14px !important;

          width: 210px !important;
          height: 56px !important;
          max-width: calc(100vw - 24px) !important;

          padding: 5px 14px 5px 5px !important;
          gap: 9px !important;
        }

        .anacapri-omni-launcher-logo {
          width: 46px !important;
          height: 46px !important;
          min-width: 46px !important;
          max-width: 46px !important;
          padding: 8px !important;
          border-radius: 50% !important;
          background: ${BRAND_RED} !important;
        }

        .anacapri-omni-launcher-title {
          font-size: 17px !important;
        }

        .anacapri-omni-launcher-status {
          font-size: 13px !important;
        }

        iframe[id*="Microsoft_Omnichannel"],
        iframe[id*="lcw"],
        iframe[src*="omnichannel"],
        iframe[src*="livechatwidget"],
        iframe[title*="chat"],
        iframe[title*="Chat"] {
          left: 10px !important;
          right: 10px !important;
          top: 10px !important;
          bottom: 10px !important;

          width: calc(100vw - 20px) !important;
          max-width: calc(100vw - 20px) !important;

          height: calc(100dvh - 20px) !important;
          max-height: calc(100dvh - 20px) !important;

          border-radius: 18px !important;
          clip-path: inset(0 round 18px) !important;
        }
      }

      .anacapri-hidden-omni-message {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
      }
    `;
  }

  function createCustomLauncher() {
    const existing = document.getElementById(LAUNCHER_ID);
    if (existing) existing.remove();

    const button = document.createElement("button");
    button.id = LAUNCHER_ID;
    button.type = "button";
    button.setAttribute("aria-label", "Abrir ayuda");

    button.innerHTML = `
      <img
        class="anacapri-omni-launcher-logo"
        src="${LAUNCHER_LOGO_URL}"
        alt="Anacapri"
      />
      <span class="anacapri-omni-launcher-text">
        <span class="anacapri-omni-launcher-title">Ayuda</span>
        <span class="anacapri-omni-launcher-status">Estamos en línea</span>
      </span>
    `;

    button.addEventListener("click", function () {
      openChat();
    });

    document.body.appendChild(button);
  }

  function showLauncher() {
    const launcher = document.getElementById(LAUNCHER_ID);
    if (launcher) launcher.classList.remove("is-hidden");
  }

  function hideLauncher() {
    const launcher = document.getElementById(LAUNCHER_ID);
    if (launcher) launcher.classList.add("is-hidden");
  }

  function openChat() {
    pendingStart = true;
    document.body.classList.add(OPEN_CLASS);
    hideLauncher();

    if (
      sdkReady &&
      window.Microsoft &&
      Microsoft.Omnichannel &&
      Microsoft.Omnichannel.LiveChatWidget &&
      Microsoft.Omnichannel.LiveChatWidget.SDK &&
      typeof Microsoft.Omnichannel.LiveChatWidget.SDK.startChat === "function"
    ) {
      try {
        Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
      } catch (error) {
        console.error("No se pudo abrir Omnichannel:", error);
        closeChatCleanly();
      }
    }
  }

  function closeChatCleanly() {
    pendingStart = false;
    document.body.classList.remove(OPEN_CLASS);
    showLauncher();
  }

  function bindOmnichannelEvents() {
    window.addEventListener("lcw:ready", function () {
      sdkReady = true;

      if (pendingStart) {
        openChat();
      } else {
        document.body.classList.remove(OPEN_CLASS);
        showLauncher();
      }
    });

    window.addEventListener("lcw:startChat", function () {
      document.body.classList.add(OPEN_CLASS);
      hideLauncher();
    });

    window.addEventListener("lcw:onMaximize", function () {
      document.body.classList.add(OPEN_CLASS);
      hideLauncher();
    });

    window.addEventListener("lcw:onMinimize", function () {
      closeChatCleanly();
    });

    window.addEventListener("lcw:onClose", function () {
      closeChatCleanly();
    });

    window.addEventListener("lcw:closeChat", function () {
      closeChatCleanly();
    });
  }

  function hideMessagesInDocument(doc) {
    if (!doc || !doc.body) return;

    const hiddenTexts = [
      "Se te ha asignado un agente",
      "Un agente estará con usted en breve",
      "Un agente estará con usted en breve.",
      "Se le ha asignado un agente",
      "Te hemos asignado un agente"
    ];

    const nodes = doc.querySelectorAll("div, span, p");

    nodes.forEach(function (node) {
      const text = (node.textContent || "").trim();

      const shouldHide = hiddenTexts.some(function (hiddenText) {
        return text.includes(hiddenText);
      });

      if (shouldHide) {
        node.classList.add("anacapri-hidden-omni-message");

        const parent = node.parentElement;
        if (parent && parent.textContent && parent.textContent.trim() === text) {
          parent.classList.add("anacapri-hidden-omni-message");
        }
      }
    });
  }

  function hideOmniSystemMessages() {
    hideMessagesInDocument(document);

    document.querySelectorAll("iframe").forEach(function (iframe) {
      try {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        if (!iframeDoc) return;

        hideMessagesInDocument(iframeDoc);
      } catch (error) {}
    });
  }

  function observeDomChanges() {
    const observer = new MutationObserver(function () {
      hideOmniSystemMessages();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setInterval(hideOmniSystemMessages, 700);
  }

  function loadOmnichannelWidget() {
    if (document.getElementById(LCW_SCRIPT_ID)) return;

    const script = document.createElement("script");
    script.id = LCW_SCRIPT_ID;
    script.src = "https://oc-cdn-public-sam.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js";
    script.async = true;

    script.setAttribute("data-app-id", APP_ID);
    script.setAttribute("data-lcw-version", "prod");
    script.setAttribute("data-org-id", ORG_ID);
    script.setAttribute("data-org-url", ORG_URL);

    script.setAttribute("data-hide-chat-button", "true");
    script.setAttribute("data-open-in-window", "false");
    script.setAttribute("data-font-family-override", "var(--font-body-family, Arial, Segoe UI)");

    script.onerror = function () {
      script.remove();

      const fallback = document.createElement("script");
      fallback.id = LCW_SCRIPT_ID;
      fallback.src = "https://ocprodpublicsamgs.blob.core.windows.net/livechatwidget/scripts/LiveChatBootstrapper.js";
      fallback.async = true;

      fallback.setAttribute("data-app-id", APP_ID);
      fallback.setAttribute("data-lcw-version", "prod");
      fallback.setAttribute("data-org-id", ORG_ID);
      fallback.setAttribute("data-org-url", ORG_URL);

      fallback.setAttribute("data-hide-chat-button", "true");
      fallback.setAttribute("data-open-in-window", "false");
      fallback.setAttribute("data-font-family-override", "var(--font-body-family, Arial, Segoe UI)");

      document.body.appendChild(fallback);
    };

    document.body.appendChild(script);
  }

  function start() {
    injectStyles();
    document.body.classList.remove(OPEN_CLASS);
    createCustomLauncher();
    bindOmnichannelEvents();
    loadOmnichannelWidget();
    observeDomChanges();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();